module.exports = __webpack_public_path__ + "static/media/david.3d41d890.png";